
export {ClayModalProvider,
Modal,
useModal,
Context,
Body,
Header,
Item,
ItemGroup,
Subtitle,
SubtitleSection,
Title,
TitleIndicator,
TitleSection} from '@clayui/modal';
import __x__ from '@clayui/modal';export default __x__;